import { Component } from "@angular/core";
import { Subscription, fromEvent } from "rxjs";

@Component({
  selector: "toolbox-document",
  templateUrl: "./document.component.html",
  styleUrls: ["./document.component.scss"],
})
export class DocumentComponent {
  private onMouseMoveSubscription: Subscription;
  documentWidth = 500;

  get documentWidthStyle(): any {
    return {
      width: `${this.documentWidth}px`,
    };
  }

  get separatorLeftStyle(): any {
    return {
      left: `${this.documentWidth}px`,
    };
  }


  stopTrackingMouse(): void {
    if (this.onMouseMoveSubscription) {
      this.onMouseMoveSubscription.unsubscribe();
    }
  }

  startTrackingMouse(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();

    const xDelta = event.clientX - this.documentWidth;
    this.onMouseMoveSubscription = fromEvent<MouseEvent>(document, "mousemove", { passive: true })
      .subscribe(e => {
        e.stopPropagation();
        e.preventDefault();

        setTimeout(() => {
          this.documentWidth = e.clientX - xDelta;
        });
      });
  }
}
